import { render } from "./ZoneDeleteDialog.vue?vue&type=template&id=0c881b60"
import script from "./ZoneDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ZoneDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__